import React, { FC, useContext } from 'react';
import classNames from 'classnames';

import Tools from '../Tools';
import QuestionIcon from '../QuestionIcon';
import CopyQuestionAnswer from '../CopyQuestionAnswer';
import WithEventRole from 'components/user/WithEventRole';
import QlPreview from 'components/common/QuillEditor/QlPreview';
import { QuestionContext } from 'components/events/Timeline/TimelineQuestionsBlock/TimelineQuestionsContext';

import { EventUserType } from 'types/enums';

import useStyles from './style';

const QuestionHeader: FC = () => {
  const classes = useStyles();

  const { question } = useContext(QuestionContext);
  const title = question.question.title;

  return (
    <div className={classNames('questionHeader', classes.header)}>
      <QuestionIcon question={question} />
      <div className={classNames('questionTitle', classes.questionTitle)}>
        <div className="edit-wrapper">
          <QlPreview text={title} className={classes.text} />
          {!!question.question.updated ? <div className="edit-mark">(Edited)</div> : null}
        </div>
        <CopyQuestionAnswer value={title} />
      </div>
      <WithEventRole roles={[EventUserType.dj]}>
        <Tools />
      </WithEventRole>
    </div>
  );
};

export default QuestionHeader;
